import {FETCH_CONTACTUS} from './types';
import salomapi from '../apis';

export const fetchContactus =  () => async dispatch => {
    const response = await salomapi.get('/contact');
    dispatch({type:FETCH_CONTACTUS,payload:response.data})
}